<template>
  <div class="app-container">
    <div class="nav-container">
      <h1><router-link to="/">Malik Blackman</router-link></h1>
      <nav>
        <!-- <router-link to="/">home</router-link> | -->
        <router-link to="/art">Art</router-link>
        <!-- <router-link to="/music">music</router-link> | -->
        <!-- <router-link to="/engineering">engineering</router-link> | -->
        <router-link to="/about">About</router-link>
        <router-link to="/contact">Contact</router-link>
      </nav>
    </div>
    <div class="content-container">
      <router-view/>
    </div>
  </div>
</template>

<style lang="scss">
body {
  background-color: #FFFFFF;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

a {
  text-decoration: none;
  color: inherit;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.nav-container {
  h1 {
    text-transform: uppercase;
    font-weight: 900;
    font-size: 1.5rem;
  }
}

.content-container {
  flex: 1 1 auto;
  min-height: 0;
}

nav {
  padding: 1.5rem;

  a {
    padding-left: 1rem;

    &.router-link-exact-active {
      color: #774936;
    }
  }
}

h2 {
  color: #774936;
  margin: 1.5rem;
}

</style>
